import { NavLink, useNavigate } from "react-router-dom";
import "./Navbar.css";

export default function Navbar() {
    const navigate = useNavigate();
    const token = localStorage.getItem("access_token");
    const username = localStorage.getItem("username");

    const handleLogout = () => {
        localStorage.removeItem("access_token");
        localStorage.removeItem("refresh_token");
        localStorage.removeItem("username");
        localStorage.removeItem("role");
        navigate("/login", { replace: true });
    };

    return (
        <nav className="navbar">
            <div className="navbar-logo">🏢 Rental Manager</div>

            <div className="nav-links">
                {!token ? (
                    <NavLink className="nav-item" to="/login">
                        <span className="nav-icon">🔐</span>
                        Hyrje
                    </NavLink>
                ) : (
                    <>
                        <NavLink className="nav-item" to="/">
                            <span className="nav-icon">🏠</span>
                            Kreu
                        </NavLink>

                        <NavLink className="nav-item" to="/dashboard">
                            <span className="nav-icon">📊</span>
                            Paneli Statistik
                        </NavLink>

                        <NavLink className="nav-item" to="/apartments">
                            <span className="nav-icon">🏢</span>
                            Apartamente
                        </NavLink>

                        <NavLink className="nav-item" to="/tenants">
                            <span className="nav-icon">👤</span>
                            Qiramarrës
                        </NavLink>

                        <NavLink className="nav-item" to="/payment-manager">
                            <span className="nav-icon">💳</span>
                            Regjistro Pagesë
                        </NavLink>

                        <NavLink className="nav-item" to="/payment-list">
                            <span className="nav-icon">📄</span>
                            Lista e Pagesave
                        </NavLink>

                        <button
                            type="button"
                            className="nav-item nav-logout"
                            onClick={handleLogout}
                        >
                            <span className="nav-icon">🚪</span>
                            Dil
                        </button>

                        {username && (
                            <span className="nav-user">
                                Admin: {username}
                            </span>
                        )}
                    </>
                )}
            </div>
        </nav>
    );
}

